var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewThread(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5894 11.8259L4.08941 3.57593C3.82541 3.44393 3.50816 3.47994 3.27866 3.66669C3.04991 3.85419 2.95241 4.15868 3.03041 4.44443L5.02166 11.7472H13.5042V13.2472H5.02166L3.03041 20.5499C2.95241 20.8349 3.04991 21.1394 3.27866 21.3269C3.41516 21.4387 3.58391 21.4972 3.75416 21.4972C3.86816 21.4972 3.98291 21.4702 4.08941 21.4177L20.5894 13.1677C20.8437 13.0409 21.0042 12.7807 21.0042 12.4972C21.0042 12.2129 20.8437 11.9527 20.5894 11.8259Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewThread);
export default __webpack_public_path__ + "static/media/new-thread.e63f388f718ebd45299673d7c29119a1.svg";
export { ForwardRef as ReactComponent };